import wx from 'weixin-js-sdk';
import { queryWxConfig } from '@/apis/weixin';

//获取微信配置信息
const getWxConfig = function (url, successFun) {
    queryWxConfig(url || location.origin).then(r => {
        let jsConfig = r.data
        wx.config({
            debug: false,
            appId: jsConfig.appId,
            timestamp: jsConfig.timestamp,
            nonceStr: jsConfig.nonceStr,
            signature: jsConfig.signature,
            jsApiList: ["showOptionMenu", "onMenuShareTimeline", "onMenuShareAppMessage", "onMenuShareQQ", "onMenuShareWeibo", "onMenuShareQZone", "scanQRCode", "hideMenuItems", "getLocation", "chooseImage", "uploadImage", "downloadImage", "getLocalImgData"]
        });
        successFun();
    })
    
  }
const chooseImg = function (successFun) {
  wx.ready(function () {
    wx.chooseImage({
      count: 1, // 默认9
      sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
      sourceType: ['album'], // 可以指定来源是相册还是相机，默认二者都有
      success: function (res) {
        
        console.log('已选择的图片==', res)
        debugger
        var localIds = res.localIds[0]
        // alert('已选择 ' + res.localIds.length + ' 张图片');
        if (window.__wxjs_is_wkwebview) {
        // if (typeof wx !== 'undefined' && wx.miniProgram) {
          wx.getLocalImgData({
            localId: localIds, // 图片的localID
            success: function (res2) {
              console.log('获取本地图片base64数据==', res2)
              var localData = res2.localData // localData是图片的base64数据，可以用img标签显示
              localData = localData.replace('jgp', 'jpeg') //iOS 系统里面得到的数据，类型为 image/jgp,因此需要替换一下
              wx.uploadImage({
                localId: localIds, // 需要上传的图片的本地ID，由chooseImage接口获得
                isShowProgressTips: 1, // 默认为1，显示进度提示
                success: function (res3) {
                  console.log('上传图片至微信服务器==', res3)
                  successFun(res3, localData)
                },
              })
            },
          })
        } else {
          console.log('333333')
          wx.uploadImage({
            localId: localIds, // 需要上传的图片的本地ID，由chooseImage接口获得
            isShowProgressTips: 1, // 默认为1，显示进度提示
            success: function (res3) {
              successFun(res3, localIds)
            },
          })
        }
      },
      fail: function (fail) {
        console.log('fail=', fail)
      },
    })
  })
}

export {
    getWxConfig,
    chooseImg
}